import React, { Dispatch, ReactNode, SetStateAction } from 'react';
import {
  BlockInteractionsState,
  ButtonKeys,
  ButtonsType,
  ButtonType,
  CloseSecondaryView,
  GetModalProps,
  GetSecondaryViewProps,
  ViewExists,
} from '../BlockInteractionsTypes';
import { ConnectActionForm } from '../forms/ContentActionForm/ConnectActionForm';
import { DeleteBlockForm } from '../forms/DeleteBlockForm/DeleteBlockForm';
import { ContentWrapperContext } from '../../../blocks/ContentWrapper/ContentWrapperContext';
import { ActionViews, DISPLAY_TYPE, Views } from '../BlockInteractions.utils';
import { ErrorBoundary } from '../../../../_lib/components/ErrorBoundary/ErrorBoundary';
import ModalDialog from '../../ModalDialog/ModalDialog';
import { ModalDialogModifier } from '../../ModalDialog/ModalDialog.modifier';
import { SubmitOrCancelForm } from '../forms/SubmitOrCancelForm/SubmitOrCancelForm';

type SecondaryView = {
  uuid: string;
  state: BlockInteractionsState;
  setState: Dispatch<SetStateAction<BlockInteractionsState>>;
  buttons?: ButtonsType;
  elementType: string;
  contentWrapperProps?: ContentWrapperContext | null;
  getSecondaryViewProps: GetSecondaryViewProps;
  closeSecondaryView: CloseSecondaryView;
  viewExists: ViewExists;
  getModalProps: GetModalProps;
};

/** returns the secondaryView component */
export function SecondaryView({
  uuid,
  state,
  setState,
  buttons,
  contentWrapperProps,
  getSecondaryViewProps,
  closeSecondaryView,
  viewExists,
  getModalProps,
}: SecondaryView) {
  const { secondaryView } = state;

  const getSecondaryView = (): ReactNode => {
    if (buttons && buttons[secondaryView as keyof Record<ButtonKeys, ButtonType>]?.View) {
      return buttons[secondaryView as keyof Record<ButtonKeys, ButtonType>].View;
    }

    switch (secondaryView) {
      case 'connectBlocks':
        return (
          <ConnectActionForm
            actionType={secondaryView}
            form={contentWrapperProps?.actions[secondaryView]}
            {...getSecondaryViewProps()}
          />
        );
      case 'deleteBlock':
        return (
          <DeleteBlockForm
            refreshBlock={() => {
              contentWrapperProps?.refetch(uuid);
              setState({ ...state, secondaryView: undefined });
            }}
            cancelAction={closeSecondaryView}
            {...getSecondaryViewProps()}
          />
        );
      case Views.DELETE:
      case Views.JOIN:
      case Views.JOINREQUEST:
      case Views.LEAVE:
        return <SubmitOrCancelForm cancelAction={closeSecondaryView} {...getSecondaryViewProps()} />;
      default:
        return null;
    }
  };

  if (secondaryView && viewExists(secondaryView)) {
    const View = getSecondaryView();
    if (View) {
      const v = buttons && buttons[secondaryView as any];
      if (
        ActionViews.includes(secondaryView) ||
        v?.displayType === DISPLAY_TYPE.MODAL ||
        v?.displayType === DISPLAY_TYPE.MODAl_WIDE
      ) {
        return (
          <ModalDialog
            closeModal={closeSecondaryView}
            {...getModalProps()}
            modifier={v?.displayType === DISPLAY_TYPE.MODAl_WIDE ? ModalDialogModifier.WIDE : undefined}
          >
            {View}
          </ModalDialog>
        );
      }
      return <ErrorBoundary>{View}</ErrorBoundary>;
    }
  }
}
